var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityItems } from './entity-items';
import { CellLabel } from '../elements/cell-label';
import { SliceConnectionsBody } from './slice-connections-body';
import { useSliceConnections } from '../hooks/use-slice-connections';
var cls = classNames('slice-entity-items');
export var SliceConnectionsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    padding-bottom: ", ";\n  "], ["\n    color: ", ";\n    padding-bottom: ", ";\n  "])), theme.COLOR('mid'), theme.UNIT(4))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceConnections',
  Container: styled.section(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled(SliceConnectionsBody)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled(CellLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Items: styled(EntityItems)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles)
};
export var SliceConnections = function (props) {
  var componentProps = useComponentProps(My.NAME, props, SliceConnectionsDefaultProps);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    _a = componentProps.fieldNames,
    fieldNames = _a === void 0 ? [] : _a,
    rest = __rest(componentProps, ["className", "children", "entity", "fieldNames"]);
  var defn = useSliceConnections(entity);
  if (!defn.shouldRender) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, defn.label), React.createElement(My.Body, __assign({
    defn: defn
  }, rest)));
};
SliceConnections.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
// usePageEntity